ACC.carousel = {

	_autoload: [
		["bindCarousel", $(".js-owl-carousel").length >0],
		"bindJCarousel"
	],

	carouselConfig:{
		"default":{
			nav: true,
			navText: ["<span class='glyphicon glyphicon-chevron-left'></span>", "<span class='glyphicon glyphicon-chevron-right'></span>"],
			dots: false,
			rewind: true,
			responsive: {
				0: {
					items: 2,
					nav: false,
					center: true
				},
				640: {
					items: 3,
				},
				1024: {
					items: 4,
				}
			}
		},
		"rotating-image":{
			nav: false,
			dots: true,
			items: 1,
			rewind: true,
		},
		"lazy-reference":{
			nav: true,
			navText : ["<span class='glyphicon glyphicon-chevron-left'></span>", "<span class='glyphicon glyphicon-chevron-right'></span>"],
			dots: false,
			lazyLoad: false,
			rewind: true,
			responsive: {
				0: {
					items: 2,
				},
				640: {
					items: 3,
				},
				1024: {
					items: 4,
				}
			}
		}
	},

	bindCarousel: function(){

		$(".js-owl-carousel").each(function(){
			var $c = $(this)
			$.each(ACC.carousel.carouselConfig,function(key,config){
				if($c.hasClass("js-owl-"+key)){
					var $e = $(".js-owl-"+key);
					$e.owlCarousel(config);
				}
			});
		});

	},

	bindJCarousel: function ()
	{
		$(".modal-colorbox").colorbox({
			onComplete: function ()
			{
				ACC.common.refreshScreenReaderBuffer();
			},
			onClosed: function ()
			{
				ACC.common.refreshScreenReaderBuffer();
			}
		});
		$('.svw').each( function(){
	          $( this).waitForImages( function(){
	               $(this).slideView({toolTip: true, ttOpacity: 0.6, autoPlay: true, autoPlayTime: 8000});
	          });
	    });
	}

};
